import { BookOpen, Check } from "lucide-react";
import { useState } from "react";
import { apiJson, hostedSession } from "../lib/hosted";
import { useGuideEnabled } from "../lib/guide-preference";

export function GuidePreference() {
  const enabled = useGuideEnabled();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  async function change() {
    setSaving(true);
    setError("");
    try {
      const session = await hostedSession();
      await apiJson("/api/preferences/guide", {
        method: "PUT",
        headers: { "Content-Type": "application/json", "X-CHEW-CSRF": session.csrfToken },
        body: JSON.stringify({ guideEnabled: !enabled }),
      });
      window.location.reload();
    } catch {
      setError("Could not save your preference. Try again.");
      setSaving(false);
    }
  }
  return <div role="group" aria-label="Guide preference">
    <button aria-checked={enabled} disabled={saving} onClick={() => void change()} role="switch" type="button">
      <BookOpen aria-hidden="true" />
      <span><strong>Chew Guide {enabled ? "on" : "off"}</strong><small>{saving ? "Saving…" : "Guides, steps, and guide prompts across your account"}</small></span>
      {enabled && <Check aria-hidden="true" />}
    </button>
    {error && <p role="alert">{error}</p>}
  </div>;
}
